import { createSlice } from "@reduxjs/toolkit";

const fullPageSlice = createSlice({
  name: "fullPage",
  initialState: {
    mobileGame: false,
    gameProxy: false,
  },
  reducers: {
    setMobileGame: (prevState, action) => {
      const state = prevState;
      state.mobileGame = action.payload.mobileGame;
    },
    setGameProxy: (prevState, action) => {
      const state = prevState;
      state.gameProxy = action.payload.gameProxy;
    },
  },
});

export const { setMobileGame, setGameProxy } = fullPageSlice.actions;

export const mobileGameSelector = (state) => state.fullPage.mobileGame;
export const gameProxySelector = (state) => state.fullPage.gameProxy;

export default fullPageSlice.reducer;
